/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Shot_Source_Use_MarkersInputs */



/**
* | output |
* | --- |
* | "Use My Markers" |
*
* @param {Ad_Shot_Source_Use_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_use_markers = /** @type {((inputs?: Ad_Shot_Source_Use_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_Use_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez mes marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutze meine Marker")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa i miei marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте мои маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usa mis marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用我的标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("私のマーカーを使ってください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेरे मार्करों का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Use meus marcadores")
	return /** @type {LocalizedString} */ ("Use My Markers")
});